module.exports = __webpack_public_path__ + "img/about-6.a45bdfdb.jpg";